import { useTranslation } from "react-i18next";
function SffLanguage() {
  const { t, i18n } = useTranslation();
  function changeLanguage(e) {
    i18n.changeLanguage(e);
  }
  return { t, changeLanguage };
}
export default SffLanguage;
